import { render, staticRenderFns } from "./VideoLibrary.vue?vue&type=template&id=8481b876&scoped=true&"
import script from "./VideoLibrary.vue?vue&type=script&lang=js&"
export * from "./VideoLibrary.vue?vue&type=script&lang=js&"
import style0 from "./VideoLibrary.vue?vue&type=style&index=0&id=8481b876&prod&lang=scss&"
import style1 from "./VideoLibrary.vue?vue&type=style&index=1&id=8481b876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8481b876",
  null
  
)

export default component.exports